import { render } from "./monerojImg.vue?vue&type=template&id=0e2353c2"
import script from "./monerojImg.vue?vue&type=script&lang=js"
export * from "./monerojImg.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3815826973/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__